const ITEMS = [
  "ASSE HPA DECOMPRESSION",
  "MITOCHONDRIAL VOLTAGE: −70mV TARGET",
  "IDO PATHWAY INHIBITION",
  "GABA RECEPTOR SATURATION",
  "ADENOSINE BUFFERING PROTOCOL",
  "CORTISOL ZERO STATE",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee-ticker"
      className="relative border-y border-white/10 bg-ink overflow-hidden py-4"
    >
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((it, i) => (
          <span
            key={i}
            className="mx-8 font-mono text-xs uppercase tracking-[0.3em] text-[#858599] flex items-center"
          >
            {it}
            <span className="text-neon ml-16">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
